import { createStyles } from "@material-ui/core";
import theme from "./theme";

export default createStyles({

  title: {
    marginBottom: theme.spacing(2)
  },

  inputGrid: {
    marginBottom: theme.spacing(1)
  }

});